import { useState } from "react";

export const useExpandReportList = (globalSettings) => {
  const [expandedList, setExpandedList] = useState({
    sales: false,
    payments: false,
    memberships: false,
  });

  const salesReports = [
    {
      label: "Sales Summary",
      href: "daily_sales_report",
      hide: true,
    },
    {
      label: "Total Sales Summary Report New",
      href: "total_sales_summary",
      hide: true,
    },
    {
      label: "Total Sales Summary Report -BETA V2",
      href: "total_sales_summary_v2",
    },
    {
      label: "Net Revenue Summary Report -BETA V2",
      href: "net_revenue_summary_v2",
    },
    {
      label: "Total Discount Summary Report -BETA V2",
      href: "total_discount_summary_v2",
    },
    {
      label: "Net Sales Report -BETA V2",
      href: "net_sales_report_v2",
    },
    {
      label: "Total Sales Report -BETA V2",
      href: "total_sales_report_v2",
    },
    {
      label: "Membership Sales -BETA V2",
      href: "membership_sales_v2",
    },
    {
      label: "eGift Sales -BETA V2",
      href: "egift_sales_v2",
    },
    {
      label: "Retail Sales -BETA V2",
      href: "retail_sales_v2",
    },
    {
      label: "Discounts Report -BETA V2",
      href: "discounts_report_v2",
    },
    {
      label: "Wallet Debits -BETA V2",
      href: "wallet_debits_v2",
    },
    {
      label: "Wallet Credits -BETA V2",
      href: "wallet_credits_v2",
    },
    {
      label: "Total Discount Summary Report New",
      href: "total_discount_summary",
      hide: true,
    },
    {
      label: "Net Revenue Summary Report New",
      href: "net_revenue_summary",
      hide: true,
    },
    {
      label: "Net Sales Report New",
      href: "net_sales_report",
      hide: true,
    },
    {
      label: "Total Sales Report New",
      href: "gross_sales",
      hide: true,
    },
    {
      label: "Net Sales",
      href: "net_sales",
      hide: true,
    },
    {
      label: "Membership Sales New",
      href: "membership_sales",
      hide: true,
    },
    {
      label: "eGift Sales New",
      href: "egift_sales",
      hide: true,
    },
    {
      label: "Retail Sales New",
      href: "retail_sales",
      hide: true,
    },
    {
      label: "Product Sales",
      href: "item_sales",
      hide: true,
    },
    {
      label: "Category Sales",
      href: "category_sales",
      hide: true,
    },
    {
      label: "Package Sales",
      href: "package_sales",
      hide: true,
    },
    {
      label: "Pricing Variations Sales",
      href: "iv_package_sales",
      hide: true,
    },
    {
      label: "Discounts",
      href: "discounts",
      hide: true,
    },
    {
      label: "Discounts Report New",
      href: "discounts_report",
      hide: true,
    },
    {
      label: "Wallet Debits New",
      href: "wallet_debits",
      hide: true,
    },
    {
      label: "Wallet Credits New",
      href: "wallet_credits",
      hide: true,
    },
    {
      label: "Commissions",
      href: "commission_report",
      hide: true,
    },
    {
      label: "Tips Per Provider",
      href: "tip_report",
      hide: true,
    },
    {
      label: "Cancellation Fees",
      href: "cancellation_fees",
      hide: true,
    },
    {
      label: "Retail Report",
      href: "retail_report",
      hide: true,
    },
    {
      label: "Services Performed",
      href: "services_performed",
      hide: true,
    },
  ];

  const paymentsReports = [
    {
      label: "Allē + Aspire + Evolus + Xperience",
      href: "bd_aspire_report",
    },
    {
      label: "Refunds Report",
      href: "refunds_report",
    },
    {
      label: "Cost to Company",
      href: "cost_to_company",
    },
    {
      label: "eGift Cards Sold vs. Redeemed",
      href: "egift_cards",
    },
    {
      label: "eGift Cards Revenue",
      href: "egift_cards_revenue",
    },
    {
      label: "Payment Methods",
      href: "payment_methods",
    },
    {
      label: "Taxes",
      href: "taxes",
    },
    {
      label: "Treatment Plans",
      href: "treatment_plans",
    },
    {
      label: "Short Term Liability",
      href: "short_term_liability",
    },
    {
      label: "Staff Treatment",
      href: "staff_treatments",
    },
    {
      label: "Staff as Patients",
      href: "staff_as_patients",
    },
    {
      label: "ASPIRE Redemption Report",
      href: "redeemed_aspire_certificates",
    },
    {
      label: "RepeatMD Redemption Report",
      href: "repeatmd_redemption",
      hide: !globalSettings?.["repeat-md"]?.isAvailable,
    },
    {
      label: "Joya Redemption Report",
      href: "joya_redemption",
      hide: !globalSettings?.["repeat-md"]?.isAvailable,
    },
    {
      label: "Patient Wallet Liability",
      href: "patient_wallet_liability",
    },
  ];

  const membershipsReports = [
    {
      label: "Membership Dashboard",
      href: "membership_overview",
    },
    {
      label: "Membership Fees Detail",
      href: "membership_fees_detail",
    },
    {
      label: "Setup Fees Detail",
      href: "setup_fees_detail",
    },
    {
      label: "New Members Detail",
      href: "new_members_detail",
    },
    {
      label: "Active Members Detail",
      href: "active_members_detail",
    },
    {
      label: "Cancelled Members Detail",
      href: "cancelled_members_detail",
    },
    {
      label: "Membership Churn Report",
      href: "membership_churn_report",
    },
    {
      label: "Membership Decline Report",
      href: "membership_decline_report",
    },
  ];

  const updateExpandedList = (list) => {
    setExpandedList((prev) => {
      const newExpandedList = Object.keys(prev).reduce(
        (acc, key) => ({
          ...acc,
          [key]: false,
        }),
        {},
      );

      newExpandedList[list] = !prev[list];

      return newExpandedList;
    });
  };

  return {
    expandedList,
    updateExpandedList,
    salesReports,
    paymentsReports,
    membershipsReports,
  };
};
